import { DashboardHelper } from './../../../../services/dashboard.service';
import { BaseComponent } from './../../../../components/base/base.component';
import { GlobalSettingStore } from './../../../../services/stores/global-setting.store';
import { Component, Input, OnInit } from '@angular/core';
import { IYouTubeVideoModel } from '../../../../models/global-setting/global-setting.model';
@Component({
  selector: 'app-video-list',
  templateUrl: './video-list.component.html',
  styleUrls: ['./video-list.component.scss'],
  standalone: false,
})
export class VideoListComponent extends BaseComponent implements OnInit {
  @Input() styleClassName: string = '';
  public vidoeList: IYouTubeVideoModel[] = [];
  @Input() videos: IYouTubeVideoModel[] = [];
  // @Input() showVideoList: boolean = true;
  constructor(
    private globalSettingStore: GlobalSettingStore,
    private dashboardHelper: DashboardHelper,
  ) {
    super();
  }

  ngOnInit(): void {
    this.dashboardHelper.setSharedRightPanelHeaderTitle('Latest YouTube Videos');
    this.subscribers.videoList = this.globalSettingStore.$videoList.subscribe((res: any) => {
      if (res && res.length > 0) {
        this.vidoeList = res;
        // if (this.styleClassName === 'animal-dashboard') {
        //   this.vidoeList = this.vidoeList.slice(0, 3);
        // }
      }
    });
    this.subscribers.dashboardHelper = this.dashboardHelper.$showVideoList.subscribe((res: any) => {
      if (res) {
        this.styleClassName = 'video-card';
      }
    });
  }

  onVideoClick(video: IYouTubeVideoModel) {
    const link = `https://www.youtube.com/watch?v=${video.videoId}`;
    window.open(link, '_blank');
  }
}
